// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
// reportWebVitals();

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Loadfirst from './Loadfirst';
import { AuthProvider } from "./AuthContext";
import { Login } from '@mui/icons-material';
import Loadfirsts from './Loadfirst';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Loadfirst />      
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);